import React from 'react'
import classNames from 'classnames'

import style from './Avatar.module.css'

export default function Avatar({ content = '', className, state }) {
  const label =
    typeof content === 'string'
      ? formatAsFirstTwoInitials(content)
      : content.toString()

  return (
    <div className={classNames(style.avatar, className, 'js-avatar')}>
      {
        {
          SUSPENDED: <Icon name="ob-suspended-icon" aria-hidden="true" />,
          REVOKED: <Icon name="ob-revoked-icon" aria-hidden="true" />,
        }[state]
      }
      <span className={style.label}>{label}</span>
    </div>
  )
}

function Icon({ name }) {
  return (
    <svg className={style.icon} style={{ color: '#707070' }}>
      <use xlinkHref={`#${name}`} />
    </svg>
  )
}

function formatAsFirstTwoInitials(str) {
  return str
    .split(' ')
    .map(w => w.toUpperCase().charAt(0))
    .slice(0, 2)
    .join('')
}
